import { axiosClient } from '../../libs/axios';

import { loadStripe } from '@stripe/stripe-js';
import { getSessionSettingsStorage } from '../session-storage';
import { CHECKOUT_ROUTE, HOME_ROUTE } from '../../router/constants';
import { removeCheckoutPresetData, removeCheckoutPresetStatus } from '../../components/checkout-preset/preset.context';
// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

export const SET_ORDER_METHOD = '[CHECKOUT APP] SET ORDER METHOD';
export const SET_ORDER_METHOD_VALIDATED = '[CHECKOUT APP] SET ORDER METHOD VALIDATED';
export const SET_CHECKOUT_DATA = '[CHECKOUT APP] SET DATA';
export const CHECKOUT_ERROR = '[CHECKOUT APP] ERROR';
export const CHECKOUT_PROCESS_DATA = '[CHECKOUT APP] PROCESS DATA';
export const CHECKOUT_PROCESS_UPDATED_DATA = '[CHECKOUT APP] PROCESS UPDATED DATA';
export const SET_ORDER_TIP_TYPE = '[CHECKOUT APP] SET ORDER TIP TYPE';
export const SET_ORDER_TIP_RATE = '[CHECKOUT APP] SET ORDER TIP RATE';
export const SET_ORDER_TIP_FIX = '[CHECKOUT APP] SET ORDER TIP FIX';
export const SET_ORDER_METHOD_TYPE = '[CHECKOUT APP] SET ORDER METHOD TYPE';
export const SET_ORDER_SCHEDULE = '[CHECKOUT APP] SET ORDER SCHEDULE';
export const SET_ORDER_SCHEDULE_TIME = '[CHECKOUT APP] SET ORDER SCHEDULE TIME';
export const SET_ORDER_SCHEDULE_IS_TIME_SLOT = '[CHECKOUT APP] SET ORDER SCHEDULE IS TIME SLOT';
export const SET_PAYMENT_METHOD = '[CHECKOUT APP] SET PAYMENT METHOD';
export const SET_ENABLE_UTENSILS_NAPKINS = '[CHECKOUT APP] SET ENABLE UTENSILS NAPKINS';
export const SET_ORDER_PROMO = '[CHECKOUT APP] SET ORDER PROMO';
export const SET_ORDER_PROMO_RESET = '[CHECKOUT APP] SET ORDER PROMO RESET';
export const SET_ORDER_PROMO_CODE = '[CHECKOUT APP] SET ORDER PROMO CODE';
export const SHOW_MINIMUM_CHECKOUT_ALERT = '[CHECKOUT APP] SHOW MINIMUM ALERT';
export const HIDE_MINIMUM_CHECKOUT_ALERT = '[CHECKOUT APP] HIDE MINIMUM ALERT';
export const SET_PIN_CODE_CONFIRMED = '[CHECKOUT APP] SET PIN CODE CONFIRMED';
export const RESET_PIN_CODE = '[CHECKOUT APP] RESET PIN CODE';
export const SET_PIN_CODE_UNCONFIRMED = '[CHECKOUT APP] SET PIN CODE UNCONFIRMED';
export const RESET_PIN_CODE_ERROR = '[CHECKOUT APP] RESET PIN CODE ERROR';
export const SET_CHECKOUT_DELIVERY_DISTANCE = '[CHECKOUT APP] SET DELIVERY DISTANCE';
export const SHOW_CARD_PROCESSING_TIMEOUT_ALERT = '[CHECKOUT APP] SHOW CARD PROCESSING TIMEOUT ALERT';
export const HIDE_CARD_PROCESSING_TIMEOUT_ALERT = '[CHECKOUT APP] HIDE CARD PROCESSING TIMEOUT ALERT';
export const SHOW_CART_CATEGORY_MIX_ALERT = '[CHECKOUT APP] SHOW CART CATEGORY MIX ALERT';
export const HIDE_CART_CATEGORY_MIX_ALERT = '[CHECKOUT APP] HIDE CART CATEGORY MIX ALERT';
export const SET_CHECKOUT_ORDER_DATA = '[CHECKOUT APP] SET ORDER DATA';
export const SET_CHECKOUT_CLIENT_NAME = '[CHECKOUT APP] SET CLIENT NAME';
export const SET_CHECKOUT_EXTERNAL_DELIVERY_DATA = '[CHECKOUT APP] SET EXTERNAL DELIVERY DATA';

export function setOrderMethod(method) {
    return {
        type: SET_ORDER_METHOD,
        method
    };
}

export function setOrderMethodValidaTed(valid) {
    return {
        type: SET_ORDER_METHOD_VALIDATED,
        valid
    };
}

export function setCheckoutData(data) {
    return {
        type: SET_CHECKOUT_DATA,
        payload: data
    }
}

export function placeOrder(restaurant, data) {
    // return dispatch =>
    //     axios.post(`${process.env.REACT_APP_API_HOST}/api/restaurant/${window.vendor}/order`, data)
    //         .then(response => {
    //             // dispatch({
    //             //     type: GET_RESTAURANT_DATA,
    //             //     payload: response.data
    //             // });
    //             // dispatch(menu.setMenuCategories(response.data.menu_categories))
    //         })

    const group_id = getSessionSettingsStorage('group_id');
    if (group_id) {
        data.group = group_id;
    }
    return async dispatch => {
        try {
            const {data: response, status} = await axiosClient.post(`/api/restaurant/${window.vendor}/order`, data);

            try {
                removeCheckoutPresetStatus();
                removeCheckoutPresetData();
            } catch (e) {
                console.error('Remove Preset Data', e)
            }
            
            dispatch(processOrderData(restaurant, response));

            // Embed mode: signal the widget host that an order was placed (analytics/pixels).
            try {
                if (window.parent && window.parent !== window) {
                    window.parent.postMessage({ type: 'fon:order-complete' }, '*');
                }
            } catch (e) {}
        }
        catch (e) {
            // const {response: {data}} = e;
            const message = e.response?.data?.error || e.response?.data?.message || e.message;
            // console.log(e, e?.response, e?.response?.data, e?.response?.data?.message)

            // The server holds an unusually large tip for confirmation (a mistyped "12.00" once
            // charged $1200): resend the same order once confirmed, otherwise go back to change it.
            if (e.response?.data?.code === 'tip_confirm_required' && !data.checkout?.confirmLargeTip) {
                if (window.confirm(`${message}\n\nPress OK to place the order with this tip, or Cancel to change it.`)) {
                    return dispatch(placeOrder(restaurant, {...data, checkout: {...data.checkout, confirmLargeTip: true}}));
                }

                window.location.replace(CHECKOUT_ROUTE);
                return;
            }

            alert(message);
            window.location.replace(HOME_ROUTE);
        }
    }
}

export function processOrderData(restaurant, data) {
    return async dispatch => {
        const { is_updated, cart, sessionId, is_card, clientSecret, success_url, cancel_url, redirect_url, token } = data;

        if (redirect_url) {
            window.location.replace(redirect_url);
            return null;
        }
        
        if (is_updated) {
            dispatch({
                type: CHECKOUT_PROCESS_UPDATED_DATA,
                payload: data
            });
            return null;
        }

        if (clientSecret) {
            dispatch({
                type: CHECKOUT_PROCESS_DATA,
                clientSecret,
                success_url,
                cancel_url,
                token
            });
            return null;
        }

        if (is_card) {
            window.location.replace(success_url);
            return null;
        }

        const stripePromise = loadStripe(restaurant.stripe_pk);
        // Call your backend to create the Checkout session.
        // const { sessionId } = await fetchCheckoutSession();
        // When the customer clicks on the button, redirect them to Checkout.
        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({
            sessionId,
        });

        // If `redirectToCheckout` fails due to a browser or network
        // error, display the localized error message to your customer
        // using `error.message`.
        if (error) {
            dispatch({
                type: CHECKOUT_ERROR,
                payload: error
            })
        }
    }
}

export function setOrderTipType(tipType) {
    return {
        type: SET_ORDER_TIP_TYPE,
        tipType
    };
}

export function setOrderTipRate(tipRate) {
    return {
        type: SET_ORDER_TIP_RATE,
        tipRate
    };
}

export function setOrderTipFix(tipFix) {
    return {
        type: SET_ORDER_TIP_FIX,
        tipFix
    };
}

export function setOrderMethodType(method) {
    return {
        type: SET_ORDER_METHOD_TYPE,
        method
    };
}

export function setSchedulePeriod(schedule) {
    return {
        type: SET_ORDER_SCHEDULE,
        schedule
    };
}

export function setScheduleTime(time) {
    return {
        type: SET_ORDER_SCHEDULE_TIME,
        time
    };
}

export function setScheduleIsTimeSlot(is) {
    return {
        type: SET_ORDER_SCHEDULE_IS_TIME_SLOT,
        payload: is
    };
}

export function setPaymentMethod(method) {
    return {
        type: SET_PAYMENT_METHOD,
        method
    };
}

export function toggleEnableUtensilsNapkins() {
    return {
        type: SET_ENABLE_UTENSILS_NAPKINS,
    };
}

export function setOrderPromo(code) {
    if (code.toString().length === 0) {
        return setOrderPromoReset();
    }
    return async dispatch => {
        const response = await axiosClient
            .post(`/api/restaurant/${window.vendor}/promo-check`, {code});

        if (!response.data.error) {
            dispatch({
                type: SET_ORDER_PROMO,
                promo: response.data
            });
        }
        else {
            dispatch(setOrderPromoReset());
        }
    };
}

export function setOrderPromoReset() {
    return {
        type: SET_ORDER_PROMO_RESET
    };
}

export function setOrderPromoCode(code) {
    return {
        type: SET_ORDER_PROMO_CODE,
        code
    };
}

export function showMinimumCheckoutAlert() {
    return {
        type: SHOW_MINIMUM_CHECKOUT_ALERT
    }
}

export function hideMinimumCheckoutAlert() {
    return {
        type: HIDE_MINIMUM_CHECKOUT_ALERT
    }
}

export function setCheckoutUpdatedData(data) {
    return {
        type: CHECKOUT_PROCESS_UPDATED_DATA,
        payload: data
    }
}

export function setPinCodeConfirmed(token) {
    return {
        type: SET_PIN_CODE_CONFIRMED,
        token
    }
}

export function setPinCodeUnConfirmed(message) {
    return {
        type: SET_PIN_CODE_UNCONFIRMED,
        message
    }
}

export function resetPinCodeError() {
    return {
        type: RESET_PIN_CODE_ERROR
    }
}

export function resetPinCode() {
    return {
        type: RESET_PIN_CODE
    }
}

export function sendPinCode(phone) {
    return dispatch => {
        axiosClient
            .post(`/api/restaurant/phone/auth`, {phone});
    }
}

export function verifyPinCode(phone, pinCode) {
    return async dispatch => {
        try {
            const response = await axiosClient.post(`/api/restaurant/phone/auth/confirm`, {phone, pin_code: pinCode});

            if (response.data.error) {
                dispatch(setPinCodeUnConfirmed(response.data.error));
            }
            else {
                dispatch(setPinCodeConfirmed(response.data.token));
            }
        }
        catch (e) {
            dispatch(setPinCodeUnConfirmed(e.response.data.error));
        }
    }
}

export function setCheckoutDeliveryDistance(distance) {
    return {
        type: SET_CHECKOUT_DELIVERY_DISTANCE,
        payload: distance
    }
}

export function showCardProcessingTimeoutAlert() {
    return {
        type: SHOW_CARD_PROCESSING_TIMEOUT_ALERT
    }
}

export function hideCardProcessingTimeoutAlert() {
    return {
        type: HIDE_CARD_PROCESSING_TIMEOUT_ALERT
    }
}

export function showCartCategoryMixAlert(category) {
    return {
        type: SHOW_CART_CATEGORY_MIX_ALERT,
        payload: category
    }
}

export function hideCartCategoryMixAlert() {
    return {
        type: HIDE_CART_CATEGORY_MIX_ALERT
    }
}

export function setCheckoutOrderData(data) {
    return {
        type: SET_CHECKOUT_ORDER_DATA,
        payload: data
    }
}

export function setCheckoutExternalDeliveryData(data) {
    return {
        type: SET_CHECKOUT_EXTERNAL_DELIVERY_DATA,
        payload: data,
    }
}
